var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import { BrandingSettingsColors } from './BrandingSettingsColors';
import { MediaAsset } from 'packages/media/MediaAsset';
var BrandingSettings = /** @class */ (function (_super) {
    __extends(BrandingSettings, _super);
    function BrandingSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.logo = null;
        _this.heroImage = null;
        _this.favicon = null;
        _this.colors = new BrandingSettingsColors();
        /**
         * @TODO: Remove when v2 forms is removed
         * @deprecated should not be used anymore use BrandSettingsColors: colors
         */
        _this.color = null;
        return _this;
    }
    Object.defineProperty(BrandingSettings.prototype, "elementColor", {
        /**
         * @TODO: Remove when v2 forms is removed
         * @deprecated should no longer used for Formviewer V3
         */
        get: function () {
            var _a;
            return (_a = this.color) !== null && _a !== void 0 ? _a : this.colors.primary;
        },
        enumerable: false,
        configurable: true
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    BrandingSettings.prototype.toJson = function (toSnake, asString) {
        if (toSnake === void 0) { toSnake = true; }
        if (asString === void 0) { asString = false; }
        var results = _super.prototype.toJson.call(this, toSnake, false);
        results[toSnake ? 'logo_id' : 'logoId'] = this.logo ? this.logo.id : null;
        results[toSnake ? 'hero_image_id' : 'heroImageId'] = this.heroImage ? this.heroImage.id : null;
        results[toSnake ? 'favicon_id' : 'faviconId'] = this.favicon ? this.favicon.id : null;
        delete results.logo;
        delete results.hero_image;
        return asString ? JSON.stringify(results) : results;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    BrandingSettings.prototype.fromJson = function (jsonData) {
        var data = _super.prototype.fromJson.call(this, jsonData);
        /**
         * Adds backwards compatibility for v2 forms using
         * brand color and not v3 derivated colors.
         *
         * @TODO: Remove when V2 forms is removed
         */
        if (data.hasOwnProperty('colors') && data.colors.primary) {
            this.color = data.colors.primary;
        }
        return data;
    };
    var _a, _b, _c, _d;
    __decorate([
        Type(MediaAsset),
        __metadata("design:type", typeof (_a = typeof MediaAsset !== "undefined" && MediaAsset) === "function" ? _a : Object)
    ], BrandingSettings.prototype, "logo", void 0);
    __decorate([
        Type(MediaAsset),
        __metadata("design:type", typeof (_b = typeof MediaAsset !== "undefined" && MediaAsset) === "function" ? _b : Object)
    ], BrandingSettings.prototype, "heroImage", void 0);
    __decorate([
        Type(MediaAsset),
        __metadata("design:type", typeof (_c = typeof MediaAsset !== "undefined" && MediaAsset) === "function" ? _c : Object)
    ], BrandingSettings.prototype, "favicon", void 0);
    __decorate([
        Type(BrandingSettingsColors),
        __metadata("design:type", typeof (_d = typeof BrandingSettingsColors !== "undefined" && BrandingSettingsColors) === "function" ? _d : Object)
    ], BrandingSettings.prototype, "colors", void 0);
    return BrandingSettings;
}(Entity));
export { BrandingSettings };
